import { FormControlLabel } from '@mui/material';
import { styled } from '@mui/system';
import { FlexLayout, Spacer } from '@Styled/utilities';
import React, { FC } from 'react';
import { TypedTestQuestion } from '../../Types/TestQuestion';
import { QuestionContentExpanded } from './QuestionAccordion.styled';
import { renderFormulasInHtml } from '@RichTextEditor';

type Props = {
	question: TypedTestQuestion<'gap'>;
};
const GAPAccordion: FC<Props> = ({ question }) => {
	const replaceGaps = () => {
		let str = question.parsed_content;
		question.fillInTheGapOptions.forEach((gap) => {
			const choices: [] = JSON.parse(gap.choices);
			if (str) {
				str.replace(`$$${gap.gap}`, choices.join(' | '));
			}
		});
		return str;
	};
	return (
		<FlexLayout flexDirection="column">
			<QuestionContentExpanded>
				{/* {replaceGaps()} */}
				<div
					dangerouslySetInnerHTML={{
						__html: renderFormulasInHtml(question.content),
					}}
				/>
			</QuestionContentExpanded>
			<Spacer mb="2rem" />
			<FlexLayout flexDirection="column"></FlexLayout>
		</FlexLayout>
	);
};

export default GAPAccordion;

const MCQAnswerLabel = styled(FormControlLabel)<{ is_correct: boolean }>`
	width: 100%;
	overflow: hidden;
	background-color: ${(props) => (props.is_correct ? '#e5fbf0' : '')};
	padding: 0 0.5rem;
	border-radius: 4px;
`;
